// Tiny PR utilities: track best set PR and daily PR streak in localStorage
// Keep it tiny to respect bundle budget

const BEST_KEY = 'pt.best_set'
const STREAK_KEY = 'pt.pr_streak' // stores { day:string, streak:number }

function todayKey(ts = Date.now()) {
  const d = new Date(ts)
  return `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')}`
}

export function getBestSet(): number {
  try { return Number(localStorage.getItem(BEST_KEY) || '0') } catch { return 0 }
}

export function setBestSet(v: number) {
  try { localStorage.setItem(BEST_KEY, String(Math.max(0, v))) } catch { /* ignore */ }
}

export function updatePrStreak(didPrToday: boolean) {
  const today = todayKey()
  let streak = 0
  try {
    const raw = localStorage.getItem(STREAK_KEY)
    if (raw) {
      const obj = JSON.parse(raw)
      if (obj && obj.day === today) {
        streak = obj.streak
      } else {
        // If yesterday had PR and today also PR -> increment; else reset when PR today only
        streak = didPrToday ? ((obj && obj.day === todayKey(Date.now()-86400000)) ? (obj.streak||0)+1 : 1) : (obj && obj.day === today ? obj.streak||0 : 0)
      }
    } else {
      streak = didPrToday ? 1 : 0
    }
    localStorage.setItem(STREAK_KEY, JSON.stringify({ day: today, streak }))
  } catch { /* ignore */ }
  return streak
}

export function getPrStreak(): number {
  try {
    const raw = localStorage.getItem(STREAK_KEY)
    const obj = raw ? JSON.parse(raw) : null
    return obj && obj.day === todayKey() ? (obj.streak||0) : 0
  } catch { return 0 }
}
